import { MessageCircle } from 'lucide-react'

import { ContactSupportAction } from '@/customer/components/contact-support-action'
import { PublicPage } from '@/customer/components/public-page'
import { Alert, AlertAction, AlertDescription, AlertTitle } from '@/customer/components/ui/alert'

/**
 * Placeholder landing for the annual renewal email link during the
 * transition off the old member portal. Replaces the legacy renewal
 * flow until the new customer-portal renewal page ships.
 */
export function SubscriptionRenewalPage() {
  return (
    <PublicPage
      className="max-w-2xl"
      headline={[
        { text: 'Renew your', color: 'yellow' },
        { text: 'subscription', color: 'blue' },
      ]}
    >
      <div className="space-y-4 text-body-md">
        <p>
          Your Snoots annual membership is coming up for renewal, and we'd love to keep caring for
          your pet for another year.
        </p>
        <p>
          Renew for another year at <strong>£396/year</strong> and we'll include a free{' '}
          <strong>Snoots Wellness Screen</strong> (RRP £350) - our most comprehensive health check,
          designed to give a complete view of your pet's internal wellbeing.
        </p>
        <p>The Wellness Screen covers:</p>
        <ul className="ml-5 list-disc space-y-1">
          <li>Organ function - liver and kidney health</li>
          <li>Nutrition and metabolism</li>
          <li>Hydration and electrolytes</li>
          <li>Thyroid and hormone levels</li>
          <li>Full urine analysis</li>
          <li>Blood count and immune health</li>
        </ul>
        <p>
          These insights help us catch early signs of disease, track subtle changes, and tailor your
          pet's care for the year ahead.
        </p>
        <p>
          Prefer not to renew annually? No problem - your plan will simply roll over to our monthly
          membership (<strong>£36/month</strong>) using your existing payment details at your next
          renewal date.
        </p>
      </div>
      <Alert variant="warning">
        <MessageCircle />
        <AlertTitle>Ready to renew for another year?</AlertTitle>
        <AlertDescription>
          Message the team on WhatsApp and we'll get it sorted, including your free Wellness Screen.
        </AlertDescription>
        <AlertAction>
          <ContactSupportAction />
        </AlertAction>
      </Alert>
    </PublicPage>
  )
}
